const errorParser = (err) => {
  const data = err?.data

  let message = null
  let messages = []

  if (typeof data === 'string') {
    message = data
  } else {
    Object.keys(data).forEach((key) => {
      const value = data?.[key]
      if (Array.isArray(value)) {
        message = value[0]
        messages = value
      } else {
        message = value
      }
    })
  }

  return {
    message,
    messages,
  }
}

export const setError = (err) => {
  const msg = errorParser(err)
  const newErr = { ...err, ...msg }
  return newErr
}

export default { setError }
